(function(){
  function isMobile(){ return window.matchMedia && window.matchMedia('(max-width: 768px)').matches; }

  function formatMoney(cents){
    try{ return (cents/100).toLocaleString(undefined,{style:'currency',currency:'USD'}); }
    catch(e){ return '$' + (cents/100).toFixed(2); }
  }

  function init(){
    var bar = document.querySelector('[data-sticky-atc]');
    if(!bar) return;

    var btn = bar.querySelector('[data-sticky-atc-btn]');
    var priceEl = bar.querySelector('[data-sticky-atc-price]');

    function currentPriceCents(){
      // Try variant price from common theme inputs
      var v = document.querySelector('[name="id"]');
      // fallback: parse visible price
      var priceText = document.querySelector('[data-product-price], .product__price, .product-single__price');
      return null;
    }

    function syncPrice(){
      // Best-effort: pull from product JSON in window meta if available
      try{
        var jsonEl = document.querySelector('script[type="application/json"][data-product-json], script[type="application/json"].product-json');
        if(jsonEl){
          var p = JSON.parse(jsonEl.textContent);
          var variantId = null;
          var idInput = document.querySelector('form[action*="/cart/add"] [name="id"], form.product-single__form [name="id"], [name="id"]');
          if(idInput) variantId = parseInt(idInput.value,10);
          var variant = (p.variants||[]).find(function(v){ return v.id === variantId; }) || (p.variants||[])[0];
          if(variant && typeof variant.price === 'number'){
            priceEl.textContent = formatMoney(variant.price);
            return;
          }
        }
      }catch(e){}
      // fallback: scrape common price element
      var pe = document.querySelector('[data-product-price]') || document.querySelector('.product__price') || document.querySelector('.product-single__price');
      if(pe) priceEl.textContent = pe.textContent.trim();
    }

    function showHide(){
      if(!isMobile()){
        bar.hidden = true;
        return;
      }
      var atc = document.querySelector('[data-add-to-cart]');
      if(!atc){ bar.hidden = true; return; }
      var rect = atc.getBoundingClientRect();
      // Show when ATC is scrolled off-screen
      bar.hidden = rect.top < window.innerHeight && rect.bottom > 0;
    }

    btn.addEventListener('click', function(){
      var atc = document.querySelector('[data-add-to-cart]');
      if(atc) atc.click();
    });

    window.addEventListener('scroll', showHide, {passive:true});
    window.addEventListener('resize', function(){ syncPrice(); showHide(); }, {passive:true});
    document.addEventListener('change', function(e){
      if(e.target && (e.target.name === 'id' || e.target.closest('[name="id"]'))){
        syncPrice();
      }
    });

    syncPrice();
    showHide();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
